import React from "react";
import { useTranslation } from "react-i18next";
import "./Whychoose.css";

const Whychoose = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="whychoose-content">
        <h1 className="whychoose-heading">{t("foodarna.services.title")}</h1>
        <div className="whychoose-container">
          {t("foodarna.services.items", { returnObjects: true }).map((item, index) => (
            <div className="whychoose-card" key={index}>
              <h1>{item.title}</h1>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Whychoose;
